// Shared PO payment-state + formatting helpers (table chips, badge, analytics).
export const PAYMENT_STATES = ['paid', 'pending', 'overdue', 'cancelled'];

export const PAYMENT_META = {
  paid: { label: 'Paid', dot: 'bg-emerald-500', text: 'text-emerald-700', pill: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  pending: { label: 'Pending', dot: 'bg-amber-500', text: 'text-amber-700', pill: 'bg-amber-50 text-amber-700 border-amber-200' },
  overdue: { label: 'Overdue', dot: 'bg-red-500', text: 'text-red-700', pill: 'bg-red-50 text-red-700 border-red-200' },
  cancelled: { label: 'Cancelled', dot: 'bg-slate-400', text: 'text-slate-600', pill: 'bg-slate-100 text-slate-600 border-slate-200' },
};

export function getPaymentState(po) {
  const status = (po?.status || '').toLowerCase();
  if (['cancelled', 'rejected', 'void'].includes(status)) return 'cancelled';
  if (status === 'paid' || status === 'completed') return 'paid';
  const due = po?.due_date ? new Date(po.due_date) : null;
  if (due && !isNaN(due)) {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    if (due < today) return 'overdue';
  }
  return 'pending';
}

export const inr = (n) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Number(n) || 0);

export const inrCompact = (n) => {
  const v = Number(n) || 0;
  const abs = Math.abs(v);
  if (abs >= 1e7) return `₹${(v / 1e7).toFixed(abs >= 1e8 ? 0 : 1)}Cr`;
  if (abs >= 1e5) return `₹${(v / 1e5).toFixed(abs >= 1e6 ? 0 : 1)}L`;
  if (abs >= 1e3) return `₹${(v / 1e3).toFixed(abs >= 1e4 ? 0 : 1)}K`;
  return `₹${Math.round(v)}`;
};

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Indian financial year runs April → March.
export function datePreset(key) {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const fyStart = m >= 3 ? y : y - 1;
  switch (key) {
    case 'this_month': return { from: ymd(new Date(y, m, 1)), to: ymd(new Date(y, m + 1, 0)) };
    case 'last_month': return { from: ymd(new Date(y, m - 1, 1)), to: ymd(new Date(y, m, 0)) };
    case 'this_quarter': {
      const q = Math.floor(m / 3) * 3;
      return { from: ymd(new Date(y, q, 1)), to: ymd(new Date(y, q + 3, 0)) };
    }
    case 'this_fy': return { from: ymd(new Date(fyStart, 3, 1)), to: ymd(new Date(fyStart + 1, 2, 31)) };
    case 'last_fy': return { from: ymd(new Date(fyStart - 1, 3, 1)), to: ymd(new Date(fyStart, 2, 31)) };
    default: return { from: '', to: '' };
  }
}

export const DATE_PRESETS = [
  { key: 'all', label: 'All time' },
  { key: 'this_month', label: 'This month' },
  { key: 'last_month', label: 'Last month' },
  { key: 'this_quarter', label: 'This quarter' },
  { key: 'this_fy', label: 'This FY' },
  { key: 'last_fy', label: 'Last FY' },
];
